import { FolderListService } from '@/domains/detail/folder-list/types/folder-list-service.interface';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { createSharedComposable } from '@vueuse/core';
import { computed, ref } from 'vue';
import { useDetailRouter } from '../use-detail-router';
import { FolderTreeService } from '@/domains/detail/folder-list/types/folder-list-tree-service.interface';
import { useDetailRoute } from '../use-detail-route';
import _ from 'lodash';
import { FOLDER_EDITABLE_FIELDS } from '@/domains/detail/folder-list/constants';
import { treeFind } from '@/infrastructure/utils/array';
import { useInitCurrentFolder } from './use-init-current-folder';
export const useFolderList = createSharedComposable(() => {
    const folderListService = injectService(FolderListService);
    const folderTreeService = injectService(FolderTreeService);
    const folderList = ref([]);
    const loadingFolderList = ref(true);
    const { spaceId, folderId: currentFolderId } = useDetailRoute();
    const { updateFolderId, refreshPage } = useDetailRouter();
    const { showNoFolderErrorTip } = useInitCurrentFolder();
    const filterKeyword = ref('');
    folderListService.subscribe((list) => {
        folderList.value = list;
    });
    /** 拍平的 folderList, 去掉 children 字段 */
    const flattenFolderList = computed(() => {
        return folderTreeService.flattenFolderList(folderList.value);
    });
    function updateFolderHasNewPatentsById(folderId, hasNewPatents) {
        folderListService.updateFolderById(folderId, { has_new_patents: hasNewPatents });
    }
    const initFolderList = async () => {
        try {
            loadingFolderList.value = true;
            await folderListService.initFolderList(spaceId.value);
            // 当前文件夹不显示红点，防止初始化时显示红点
            updateFolderHasNewPatentsById(currentFolderId.value, false);
        }
        finally {
            loadingFolderList.value = false;
        }
    };
    const switchFolder = (folderId) => {
        updateFolderId(folderId);
    };
    const filterFolderList = computed(() => {
        return folderTreeService.filterFolderList(folderList.value, filterKeyword.value);
    });
    function addFolder(patentId, folder) {
        folderListService.addFolder(patentId, folder);
    }
    function updateFolderById(folderId, folder) {
        folderListService.updateFolderById(folderId, _.pick(folder, FOLDER_EDITABLE_FIELDS));
    }
    function updateFolderCountById(folderId, folderCount) {
        folderListService.updateFolderById(folderId, folderCount);
    }
    /**
     * 获取 folderList 中指定 id 的 folder（包括 children 中的）
     */
    function getFolderById(folderId) {
        return folderListService.getFolderById(folderId);
    }
    function switch2firstFolder() {
        const targetFolderId = _.get(folderListService.folderList, '[0].folder_id');
        if (targetFolderId) {
            switchFolder(targetFolderId);
        }
        else {
            refreshPage();
            showNoFolderErrorTip();
        }
    }
    function deleteFolder(spaceId, folderId) {
        // 应该同时判断其子级是否包含 currentFolderId
        const shouldDeletedFolder = getFolderById(folderId);
        const currentFolderWillDeleted = shouldDeletedFolder && treeFind(shouldDeletedFolder, 'children', item => item.folder_id === currentFolderId.value);
        return folderListService.deleteFolder(spaceId, folderId).then(() => {
            if (currentFolderWillDeleted) {
                switch2firstFolder();
            }
        });
    }
    async function movedFolder(folderId) {
        await initFolderList();
        if (!getFolderById(folderId)) {
            // 移出了当前 space
            switch2firstFolder();
        }
    }
    return {
        filterKeyword,
        folderList,
        filterFolderList,
        loadingFolderList,
        flattenFolderList,
        initFolderList,
        switchFolder,
        addFolder,
        updateFolderById,
        updateFolderCountById,
        updateFolderHasNewPatentsById,
        deleteFolder,
        movedFolder,
        getFolderById,
    };
});
